<template>
  <div class="catalog-list" @mouseleave="showChild = false" :class="{ showChild: showChild }">
    <div :class="{ 'index-list': proxy.$route.fullPath == '/', isScrollBar: isScrollBar }" ref="scrollableElement">
      <div
        class="catalog-one"
        v-for="(item, index) in checkCategoryList"
        :class="{ 'catalog-one-active': showChild && catalogChild == item.children && item.children }"
        :key="'catalog-one' + index"
        @mouseover="changeChild(item.children)"
      >
        <div class="catalog-title flex">
          <div>
            {{ item.name }}
            <span class="text-$el-color-error font-bold animate-flash" v-if="hotCateNames.includes(item.name)"
              >HOT</span
            >
          </div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>

    <div class="catalog-child-wrap" v-show="showChild">
      <div class="catalog-child" v-for="(item, index) in catalogChild" :key="'catalog-child' + index">
        <el-tooltip
          popper-class="hztooltip"
          effect="dark"
          content="寻求商务合作中"
          placement="top"
          :disabled="item.existStatus == 1"
        >
          <span
            class="catalog-child-title"
            :class="{ kohaku: item.existStatus == 0 }"
            @click="toCatalogList(item, true)"
          >
            {{ item.name }}
          </span>
        </el-tooltip>

        <div class="flex click-catalog-wrap">
          <el-tooltip
            popper-class="hztooltip"
            v-for="(iitem, iindex) in item.children"
            :key="'click-catalog' + index + iindex"
            effect="dark"
            content="寻求商务合作中"
            placement="top"
            :disabled="iitem.existStatus == 1"
          >
            <span
              class="click-catalog"
              :class="{ kohaku: iitem.existStatus == 0 }"
              @click="toCatalogList(iitem, true)"
              >{{ iitem.name }}</span
            >
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { productInfo } from '@/stores/productInfo';
import { getCategoryListTreerestful } from '@/api/product';
import { appInfo } from '@/stores/appInfo';
import { userInfo } from '@/stores/userInfo';
import * as hinaApi from '@/utils/hina';

const appStores = appInfo();
const catalogChild = ref([]);
const showChild = ref(false);
const { proxy } = getCurrentInstance();
const scrollableElement = ref(null);
const isScrollBar = ref(false);

const categoryList = ref([]);
const checkCategoryId = ref();

// 发布会开发
const hotCateNames = ['电子元器件', '处理/储存芯片', '电源/传感芯片', '通信/接口芯片'];

function getCategoryList() {
  console.log('getCategoryList');
  const appStore = appInfo();
  const userStore = userInfo();
  const payLoad = appStore.isSmallCompanyHost ? { hostId: userStore.defaultHostId } : { hostId: 1, pointFlag: 0 };
  getCategoryListTreerestful(payLoad).then(res => {
    categoryList.value = res.data;
    checkCategoryId.value = res.data?.[0]?.id;
  });
}
getCategoryList();

const checkCategoryList = computed(() => {
  const index = categoryList.value.findIndex(item => item.id == checkCategoryId.value);
  if (index !== -1) {
    const chache = categoryList.value[index].children;
    chache.forEach(item => {
      if (item.children) {
        item.children.forEach(element => {
          if (element.children) {
            element.existStatus = element.children.some(item => item.existStatus == 1) ? 1 : 0;
          }
        });
      }
    });
    return chache;
  } else {
    return [{ children: [] }];
  }
});

//切换选择到的分类的子分类
function changeChild(item) {
  catalogChild.value = item;
  showChild.value = true;
}
//点击跳转分类
function toCatalogList(item, close = false) {
  if (item.existStatus == 0) {
    return;
  }
  //点击子分类的时候关闭分类列表
  if (close) {
    showChild.value = false;
  }
  useRouter().push({
    name: 'product-list',
    query: { shopName: appStores.shopName, productCategoryId: item.id, categoryLevel: item.level },
  });

  // 点击分类
  hinaApi.homeCateClickPoint({
    cate_id: item.id,
    cate_name: item.name,
  });
}

watch(
  () => categoryList.value, // 监听的数据
  () => {
    checkScrollBar();
  }
);
//检测是否有滚动条
function checkScrollBar() {
  nextTick(() => {
    if (scrollableElement.value.scrollHeight > scrollableElement.value.clientHeight) {
      isScrollBar.value = true;
    } else {
      isScrollBar.value = false;
    }
  });
}
</script>
<style lang="scss" scoped>
.catalog-list {
  background: #fff;
  position: relative;
  line-height: 1.5 !important;
  z-index: 9;
  min-height: 300px;
  border-radius: 6px;
  padding: 2px 0;
  flex-grow: 1;

  .catalog-one {
    cursor: pointer;
    padding: 8px 16px;
    font-size: 14px;
    box-sizing: border-box;
    width: calc(200px - 16px - 16px);
    overflow: hidden;
    overscroll-behavior-y: contain;

    .catalog-title {
      line-height: 23px;
      color: $main-text-color;
    }
  }

  .catalog-one-active {
    background: #e6f9f0;
    color: $main-color;

    .catalog-title {
      color: $main-color;
    }
  }

  .catalog-child-wrap {
    position: absolute;
    left: 200px;
    top: 0;
    width: 784px;
    background: #fff;
    height: 100%;
    overflow: auto;
    padding: 20px 24px 0;
    box-sizing: border-box;
    font-size: 14px;
    border-radius: 0 6px 6px 0;
    overscroll-behavior-y: contain;

    .catalog-child {
      margin-bottom: 16px;

      .kohaku {
        color: $main-text-color2 !important;
      }

      .catalog-child-title {
        display: inline-block;
        font-weight: bold;
        cursor: pointer;
        color: #333333;
        margin-bottom: 8px;

        &:hover {
          color: $main-color;
        }
      }

      .click-catalog-wrap {
        flex-wrap: wrap;
        gap: 8px 16px;
        /* 名称之间的间隔 */
        justify-content: flex-start;

        .click-catalog {
          cursor: pointer;
          white-space: nowrap;
          color: #606266;

          &:hover {
            color: $main-color;
          }
        }
      }
    }
  }
}

.catalog-list.showChild {
  border-radius: 6px 0 0 6px;
}

.index-list {
  height: 472px;
  overflow-y: auto;

  .catalog-one {
    width: 200px;
  }
}

.isScrollBar {
  .catalog-one {
    width: calc(200px - 6px);
  }
}
</style>
<style lang="scss">
.hztooltip {
  pointer-events: none;
}
</style>
